<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div class="md-layout-item md-size-65 md-small-size-95 mx-auto">
            <h2 class="black text-center text-primary">{{$t('Invitations')}}</h2>

            <template v-if="model.items.length">
              <div
                v-for="item in model.items"
                :key="item.id"
                style="margin:0px 0px;"
                class="md-layout-item md-size-100"
              >
                <div class="notification-item" @click="showDetails(item)">
                  <span class="text-primary bold partner">{{item.partner}}:</span>
                  <span class="text-gray regular description">{{item.description.title}}</span>
                </div>
              </div>
            </template>

            <no-data v-else class="md-layout-item md-size-100" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedItem }">
      <modal v-if="selectedItem" @close="selectedItem = null">
        <template slot="header">
          <h3 class="title" style="margin:0px">{{selectedItem.description.title}}</h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedItem = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="selectedItem.description.content" />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from "@/util/axios";
import { Modal } from "@/components";
import PageHeader from "./layout/PageHeader";
import NoData from "@/pages/authenticated/NoData";

export default {
  components: { Modal, PageHeader, NoData },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },
  data() {
    return {
      loaded: false,
      selectedItem: null,
      model: { items: [] },
      image: require("@/assets/img/conference/landing-bg-new.png") // header img
    };
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.model = (
          await axios.get("public/conferences/conference/invitations", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    async showDetails(item) {
      this.selectedItem = item;
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      this.loaded = false;
      this.model = { items: [] };
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
.notification-item {
  cursor: pointer;
  margin: 0px 0px;
  padding: 7px 0px;
  display:flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0px 0px 30px #0000000d;
    border-radius: 15px;
    opacity: 1;
  }

  .partner {
    font-size:18px;
    margin:0 10px 10px 0;
  }

  .description {
    font-size:18px;
  }
}
</style>
